import { groupExitSlipResponsesByItem } from './exitSlipItemScores';

type ExitSlipItem =
  | {
      readonly score: number | null | undefined;
      readonly maxScore: number | null | undefined;
      readonly itemReference?: string | null | undefined;
    }
  | null
  | undefined;

type ExitSlipSession =
  | {
      readonly isComplete: boolean | null | undefined;
      readonly items: ReadonlyArray<ExitSlipItem> | null | undefined;
    }
  | null
  | undefined;

type ClassExitSlipLike =
  | {
      readonly learnosityExitSlipSessions: ReadonlyArray<ExitSlipSession> | null | undefined;
    }
  | null
  | undefined;

export const exitSlipAverageScore = (classExitSlips: ReadonlyArray<ClassExitSlipLike> | null | undefined): number => {
  const sessionScores = (classExitSlips ?? [])
    .map(slip => slip?.learnosityExitSlipSessions?.[0])
    .filter(session => session?.isComplete && session.items?.length)
    .map(session => {
      const items = groupExitSlipResponsesByItem(session?.items);
      const correct = items.filter(item => item.score === item.maxScore).length;
      return (correct / items.length) * 100;
    });

  if (!sessionScores.length) return 0;
  return Math.round(sessionScores.reduce((a, b) => a + b, 0) / sessionScores.length);
};
